export default {
  initData: {},
  classData: {},
  classDataEdit: {},
  classDataEditDelta: {},
};
